import React, { useEffect } from "react";
import "animate.css";
import Hero from "../components/Hero";
import BrandBanner from "../components/BrandBanner";
import AuthenticHaitianSection from "../components/AuthenticHaitianSection";
import MenuCalloutSection from "../components/MenuCalloutSection";
import AuthenticFlavorBanner from "../components/AuthenticFlavorBanner";
import MenuGridSection from "../components/MenuGridSection";
import MenuViewBanner from "../components/MenuViewBanner";
import GoogleMap from "../components/GoogleMap";
import GetStartedBanner from "../components/GetStartedBanner";
import Footer from "../components/Footer";

function HomePage() {
  useEffect(() => {
    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Small delay to ensure scroll happens before any other operations
    const scrollTimer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => {
      clearTimeout(scrollTimer);
    };
  }, []);

  const restaurantData = {
    phone: "973-350-6522",
    name: "A Plus Flavor",
    socialLinks: {
      facebook:
        "https://www.facebook.com/profile.php?id=61576392401010",
      instagram:
        "https://www.instagram.com/aplusflavorrestaurant",
    },
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <Hero />

      {/* Brand Banner */}
      <BrandBanner />

      {/* Authentic Haitian Section */}
      <div id="about">
        <AuthenticHaitianSection />
      </div>

      {/* Menu Callout Section */}
      <MenuCalloutSection />

      {/* Authentic Flavor Banner */}
      <AuthenticFlavorBanner />

      {/* Menu Grid */}
      <MenuGridSection />

      {/* Menu View Banner */}
      <MenuViewBanner />

      {/* Google Map */}
      <GoogleMap />

      {/* Get Started Banner */}
      <GetStartedBanner />

      {/* Footer */}
      <Footer restaurantData={restaurantData} />
    </div>
  );
}

export default HomePage;
